export { default } from "./DealsTable";
